export const scrollToTop = () => {
    const errors = [...document.querySelectorAll('.error-message')].filter((el) => el.innerText !== '');

    let y;

    if (errors.length) {
        y = errors[0].getBoundingClientRect().top + window.scrollY - 305;
    } else {
        const header = document.querySelector('.Header.Header--spaceTopNoFomo');
        y = -1 * header ? header.getBoundingClientRect().top + window.scrollY : 0;
    }

    window.scroll({
        top: y,
        behavior: 'smooth',
    });
};